import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RemovedItemsDialogPage } from './removed-items-dialog.page';

const routes: Routes = [
	{
		path: '',
		component: RemovedItemsDialogPage
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class RemovedItemsDialogPageRoutingModule { }

